import ShapeRectangleRoundedIcon from '@atlaskit/icon-lab/core/shape-rectangle-rounded';
import * as React from 'react';

export function SvgSquare() {
  return <ShapeRectangleRoundedIcon label="" testId="ads-refreshed-icon" />;
}
